var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page checkout" },
    [
      _c(
        "h2",
        {
          staticClass: "text-center mt-7",
          staticStyle: { "margin-bottom": "2px" },
        },
        [_vm._v("Bestellung zur Lieferung")]
      ),
      _c("div", { staticClass: "text-center" }, [
        _c("h4", {}, [
          _vm._v("Gesamtsumme: "),
          _c("span", { staticClass: "textFont" }, [
            _vm._v(_vm._s(_vm._f("priceTotal")(_vm.total))),
          ]),
        ]),
        _c("h4", [
          _vm.deliveryFee ? _c("span", [_vm._v("inkl. ")]) : _vm._e(),
          _vm._v("Liefergebühr: "),
          _c("span", { staticClass: "textFont" }, [
            _vm._v(_vm._s(_vm._f("priceTotal")(_vm.deliveryFee))),
          ]),
        ]),
        _c("h4", { staticClass: "mt-2" }, [_vm._v("Zahlung bei Lieferung")]),
      ]),
      _c(
        "v-container",
        { staticClass: "ccontainer", attrs: { "grid-list-md": "" } },
        [
          _c(
            "div",
            { staticClass: "kioskCheckoutContainer" },
            [
              _c(
                "v-stepper",
                {
                  staticClass: "vvd orderform",
                  attrs: { vertical: "", id: "stepper" },
                  model: {
                    value: _vm.currentStep,
                    callback: function ($$v) {
                      _vm.currentStep = $$v
                    },
                    expression: "currentStep",
                  },
                },
                [
                  _c(
                    "v-stepper-step",
                    {
                      attrs: { complete: _vm.currentStep > 1, step: "1" },
                      nativeOn: {
                        "&click": function ($event) {
                          _vm.currentStep = 1
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "nice-title small" }, [
                        _vm._v("Deine Bestelldaten"),
                      ]),
                    ]
                  ),
                  _c("v-stepper-content", { attrs: { step: "1" } }, [
                    _vm.usecase.length > 0
                      ? _c(
                          "div",
                          { attrs: { id: "checkData" } },
                          [
                            _c(
                              "div",
                              { staticClass: "bestelldaten pt-1" },
                              [
                                _c(
                                  "v-form",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.showForm,
                                        expression: "showForm",
                                      },
                                    ],
                                    ref: "deliveryMpDataForm",
                                    attrs: { "lazy-validation": "" },
                                    on: {
                                      submit: function ($event) {
                                        $event.preventDefault()
                                      },
                                    },
                                    model: {
                                      value: _vm.valid,
                                      callback: function ($$v) {
                                        _vm.valid = $$v
                                      },
                                      expression: "valid",
                                    },
                                  },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        outlined: "",
                                        label: "Vor- und Nachname*",
                                        placeholder: "Vorname Nachname",
                                        illed: "",
                                        "hide-details": "",
                                        required: "",
                                      },
                                      on: {
                                        focus: _vm.hideToolbar,
                                        blur: _vm.unhideToolbar,
                                      },
                                      model: {
                                        value: _vm.name,
                                        callback: function ($$v) {
                                          _vm.name = $$v
                                        },
                                        expression: "name",
                                      },
                                    }),
                                    _c("v-text-field", {
                                      attrs: {
                                        outlined: "",
                                        label:
                                          "E-Mail* (Bestelleingangsbestätigung)",
                                        placeholder: "E-Mail Adresse",
                                        illed: "",
                                        "hide-details": "",
                                        required: "",
                                      },
                                      on: {
                                        focus: _vm.hideToolbar,
                                        blur: _vm.unhideToolbar,
                                      },
                                      model: {
                                        value: _vm.email,
                                        callback: function ($$v) {
                                          _vm.email = $$v
                                        },
                                        expression: "email",
                                      },
                                    }),
                                    _c("v-text-field", {
                                      ref: "phone",
                                      attrs: {
                                        outlined: "",
                                        rules: _vm.phoneRules,
                                        label: "Mobilnummer*",
                                        placeholder: "Für evtl. Rückfragen",
                                        illed: "",
                                        required: "",
                                      },
                                      on: {
                                        keydown: function ($event) {
                                          return _vm.phoneKeydown($event)
                                        },
                                      },
                                      model: {
                                        value: _vm.phone,
                                        callback: function ($$v) {
                                          _vm.phone = $$v
                                        },
                                        expression: "phone",
                                      },
                                    }),
                                    _c("h4", { staticClass: "mt-7 mb-4" }, [
                                      _vm._v("Lieferadresse"),
                                    ]),
                                    _c("v-text-field", {
                                      attrs: {
                                        outlined: "",
                                        clearable: "",
                                        rules: _vm.streetRules,
                                        label: "Straße und Hausnummer*",
                                        illed: "",
                                        "hide-details": "",
                                        required: "",
                                      },
                                      on: {
                                        focus: _vm.hideToolbar,
                                        blur: _vm.unhideToolbar,
                                      },
                                      model: {
                                        value: _vm.deliveryAddress.street,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.deliveryAddress,
                                            "street",
                                            $$v
                                          )
                                        },
                                        expression: "deliveryAddress.street",
                                      },
                                    }),
                                    _c("v-text-field", {
                                      attrs: {
                                        outlined: "",
                                        clearable: "",
                                        label: "Postleitzahl*",
                                        rules: _vm.plzRules,
                                        illed: "",
                                        "hide-details": "",
                                        required: "",
                                      },
                                      on: {
                                        focus: _vm.hideToolbar,
                                        blur: _vm.unhideToolbar,
                                      },
                                      model: {
                                        value: _vm.deliveryAddress.plz,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.deliveryAddress,
                                            "plz",
                                            $$v
                                          )
                                        },
                                        expression: "deliveryAddress.plz",
                                      },
                                    }),
                                    _c("v-text-field", {
                                      attrs: {
                                        outlined: "",
                                        clearable: "",
                                        label: "Stadt*",
                                        rules: _vm.cityRules,
                                        illed: "",
                                        "hide-details": "",
                                        required: "",
                                      },
                                      on: {
                                        focus: _vm.hideToolbar,
                                        blur: _vm.unhideToolbar,
                                      },
                                      model: {
                                        value: _vm.deliveryAddress.city,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.deliveryAddress,
                                            "city",
                                            $$v
                                          )
                                        },
                                        expression: "deliveryAddress.city",
                                      },
                                    }),
                                    _c("v-text-field", {
                                      attrs: {
                                        outlined: "",
                                        clearable: "",
                                        label: "Etage",
                                        illed: "",
                                        "hide-details": "",
                                      },
                                      on: {
                                        focus: _vm.hideToolbar,
                                        blur: _vm.unhideToolbar,
                                      },
                                      model: {
                                        value: _vm.deliveryAddress.etage,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.deliveryAddress,
                                            "etage",
                                            $$v
                                          )
                                        },
                                        expression: "deliveryAddress.etage",
                                      },
                                    }),
                                    _c("div", [
                                      _c("img", {
                                        staticClass: "poweredByGoogleMaps",
                                        attrs: {
                                          alt: "powered by Google Maps",
                                          src: require("../assets/s-powered-by-Google-Maps.png"),
                                        },
                                      }),
                                    ]),
                                    _c("v-checkbox", {
                                      staticClass:
                                        "d-inline-block vvd-dynlight vvd-force",
                                      attrs: {
                                        label:
                                          "Rechnungsadresse gleich Lieferadresse",
                                      },
                                      model: {
                                        value: _vm.sameAsDeliveryAddress,
                                        callback: function ($$v) {
                                          _vm.sameAsDeliveryAddress = $$v
                                        },
                                        expression: "sameAsDeliveryAddress",
                                      },
                                    }),
                                    !_vm.sameAsDeliveryAddress
                                      ? _c(
                                          "div",
                                          [
                                            _c(
                                              "h4",
                                              { staticClass: "mt-7 mb-4" },
                                              [_vm._v("Rechnungsadresse")]
                                            ),
                                            _c("v-text-field", {
                                              attrs: {
                                                outlined: "",
                                                clearable: "",
                                                label: "Firma (optional)",
                                                illed: "",
                                                "hide-details": "",
                                                required: "",
                                              },
                                              on: {
                                                focus: _vm.hideToolbar,
                                                blur: _vm.unhideToolbar,
                                              },
                                              model: {
                                                value:
                                                  _vm.invoiceAddress.company,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.invoiceAddress,
                                                    "company",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "invoiceAddress.company",
                                              },
                                            }),
                                            _c("v-text-field", {
                                              attrs: {
                                                outlined: "",
                                                clearable: "",
                                                label: "Straße und Hausnummer*",
                                                illed: "",
                                                "hide-details": "",
                                                required: "",
                                              },
                                              on: {
                                                focus: _vm.hideToolbar,
                                                blur: _vm.unhideToolbar,
                                              },
                                              model: {
                                                value:
                                                  _vm.invoiceAddress.street,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.invoiceAddress,
                                                    "street",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "invoiceAddress.street",
                                              },
                                            }),
                                            _c("v-text-field", {
                                              attrs: {
                                                outlined: "",
                                                clearable: "",
                                                label: "Postleitzahl*",
                                                illed: "",
                                                "hide-details": "",
                                                required: "",
                                              },
                                              on: {
                                                focus: _vm.hideToolbar,
                                                blur: _vm.unhideToolbar,
                                              },
                                              model: {
                                                value: _vm.invoiceAddress.plz,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.invoiceAddress,
                                                    "plz",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "invoiceAddress.plz",
                                              },
                                            }),
                                            _c("v-text-field", {
                                              attrs: {
                                                outlined: "",
                                                clearable: "",
                                                label: "Stadt*",
                                                illed: "",
                                                "hide-details": "",
                                                required: "",
                                              },
                                              on: {
                                                focus: _vm.hideToolbar,
                                                blur: _vm.unhideToolbar,
                                              },
                                              model: {
                                                value: _vm.invoiceAddress.city,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.invoiceAddress,
                                                    "city",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "invoiceAddress.city",
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.$store.state.enableOrderNote
                              ? [
                                  _c("h4", { staticClass: "mt-4" }, [
                                    _vm._v("Hinweise zur Bestellung"),
                                  ]),
                                  _c("v-text-field", {
                                    staticClass: "nolabel",
                                    attrs: {
                                      "hide-details": "",
                                      clearable: "",
                                      illed: "",
                                    },
                                    model: {
                                      value: _vm.note,
                                      callback: function ($$v) {
                                        _vm.note = $$v
                                      },
                                      expression: "note",
                                    },
                                  }),
                                ]
                              : _vm._e(),
                            _c(
                              "div",
                              { staticClass: "mt-2" },
                              [
                                _vm.step1Error && _vm.initialTry
                                  ? _c(
                                      "div",
                                      { staticClass: "error--text mt-2 mb-4" },
                                      [_vm._v(_vm._s(_vm.step1Error))]
                                    )
                                  : _vm._e(),
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "primepulsing btn-df weiter",
                                    nativeOn: {
                                      "&click": function ($event) {
                                        return _vm.finishStep1.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(" Weiter ")]
                                ),
                              ],
                              1
                            ),
                          ],
                          2
                        )
                      : _vm._e(),
                  ]),
                  _c(
                    "v-stepper-step",
                    { attrs: { complete: _vm.currentStep > 2, step: "2" } },
                    [
                      _c("div", { staticClass: "nice-title small" }, [
                        _vm._v(
                          "Lieferzeit: " +
                            _vm._s(_vm.selectedAbholDatum.value) +
                            " "
                        ),
                        _vm.userSelectedHeute &&
                        _vm.timesToday.length > 0 &&
                        _vm.time
                          ? _c("span", [
                              _vm._v(", " + _vm._s(_vm.time.value) + " Uhr"),
                            ])
                          : _vm._e(),
                        !_vm.userSelectedHeute &&
                        _vm.timesTomorrow.length > 0 &&
                        _vm.time
                          ? _c("span", [
                              _vm._v(", " + _vm._s(_vm.time.value) + " Uhr"),
                            ])
                          : _vm._e(),
                      ]),
                    ]
                  ),
                  _c(
                    "v-stepper-content",
                    { attrs: { id: "lieferung", step: "2" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c("v-flex", { attrs: { xs12: "", md3: "" } }, [
                            _c(
                              "div",
                              {
                                staticClass: "d-flex flex-nowrap flex-md-wrap",
                              },
                              [
                                _c(
                                  "h4",
                                  {
                                    staticClass:
                                      "flex-shrink-0 flex-grow-0 flex-md-grow-1 mr-2 breakTitle text-no-wrap",
                                  },
                                  [_vm._v("Datum:")]
                                ),
                                _c("v-select", {
                                  attrs: {
                                    "hide-details": "",
                                    items: _vm.abholDatumArray,
                                    "item-text": "value",
                                    "return-object": "",
                                    illed: "",
                                  },
                                  model: {
                                    value: _vm.selectedAbholDatum,
                                    callback: function ($$v) {
                                      _vm.selectedAbholDatum = $$v
                                    },
                                    expression: "selectedAbholDatum",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _c("v-flex", {
                            staticClass: "hidden-sm-and-down",
                            attrs: { xs12: "", md1: "" },
                          }),
                          _c("v-flex", { attrs: { xs12: "", md4: "" } }, [
                            _c(
                              "div",
                              {
                                staticClass: "d-flex flex-nowrap flex-md-wrap",
                              },
                              [
                                _c(
                                  "h4",
                                  {
                                    staticClass:
                                      "flex-shrink-0 flex-grow-0 flex-md-grow-1 mr-2 breakTitle text-no-wrap",
                                  },
                                  [_vm._v("Lieferzeit:")]
                                ),
                                _vm.selectedAbholDatum.value === "Heute"
                                  ? _c("v-select", {
                                      class: {
                                        selectBlinker: !(
                                          _vm.time && _vm.time.value
                                        ),
                                      },
                                      attrs: {
                                        "hide-details": "",
                                        items: _vm.timesToday,
                                        "item-text": "display",
                                        "return-object": "",
                                        illed: "",
                                        placeholder: "Uhrzeit auswählen",
                                      },
                                      model: {
                                        value: _vm.time,
                                        callback: function ($$v) {
                                          _vm.time = $$v
                                        },
                                        expression: "time",
                                      },
                                    })
                                  : _vm._e(),
                                _vm.selectedAbholDatum.value === "Morgen"
                                  ? _c("v-select", {
                                      class: {
                                        selectBlinker: !(
                                          _vm.time && _vm.time.value
                                        ),
                                      },
                                      attrs: {
                                        "hide-details": "",
                                        items: _vm.timesTomorrow,
                                        "item-text": "display",
                                        "return-object": "",
                                        illed: "",
                                        placeholder: "Uhrzeit auswählen",
                                      },
                                      model: {
                                        value: _vm.time,
                                        callback: function ($$v) {
                                          _vm.time = $$v
                                        },
                                        expression: "time",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "mt-4" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "primepulsing btn-df weiter",
                              attrs: {
                                disabled:
                                  _vm.selectedAbholDatum.value.indexOf(
                                    "schlossen"
                                  ) > -1 || !(_vm.time && _vm.time.value),
                              },
                              nativeOn: {
                                "&click": function ($event) {
                                  return _vm.finishStep2.apply(null, arguments)
                                },
                              },
                            },
                            [_vm._v(" Weiter ")]
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn-df weiter grayBtn",
                              nativeOn: {
                                "&click": function ($event) {
                                  _vm.currentStep = 1
                                },
                              },
                            },
                            [_vm._v(" Zurück ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-stepper-step",
                    { attrs: { complete: _vm.currentStep > 3, step: "3" } },
                    [
                      _c("div", { staticClass: "nice-title small" }, [
                        _vm._v("Bestellung bestätigen "),
                      ]),
                    ]
                  ),
                  _c(
                    "v-stepper-content",
                    { attrs: { id: "confirmation", step: "3" } },
                    [
                      _c(
                        "div",
                        { staticClass: "mt-4" },
                        [
                          _c(
                            "div",
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass:
                                    "mt-3 orderBtn wallet-width text-none rounded100",
                                  attrs: { color: "green", dark: "" },
                                  nativeOn: {
                                    "&click": function ($event) {
                                      return _vm.doOrder.apply(null, arguments)
                                    },
                                  },
                                },
                                [_vm._v(" Zahlungspflichtig bestellen ")]
                              ),
                            ],
                            1
                          ),
                          _c("orderconsent"),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "mt-3" }, [
                        _vm._v(
                          " Die Bezahlung erfolgt bei Lieferung. " +
                            _vm._s(_vm.displayPaymentMethods()) +
                            " "
                        ),
                      ]),
                      _c(
                        "v-btn",
                        {
                          staticClass: "mt-4 btn-df weiter grayBtn",
                          attrs: { rounded: "" },
                          nativeOn: {
                            "&click": function ($event) {
                              _vm.currentStep = 2
                            },
                          },
                        },
                        [_vm._v(" Zurück ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c("ssl-seal"),
      _c(
        "div",
        { staticClass: "text-center" },
        [
          _c("div", { staticClass: "spacer-25" }),
          _c(
            "v-btn",
            {
              staticClass: "text-none btn-mini",
              staticStyle: { "margin-top": "25px" },
              on: {
                click: function ($event) {
                  return _vm.$router.go(-1)
                },
              },
            },
            [_vm._v(" Bestellung abbrechen ")]
          ),
        ],
        1
      ),
      _c("div", { staticClass: "spacer-25" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }